import { useEffect, useId, useRef, type ReactNode } from 'react'
import { Button } from './Button'
import { Notice } from './Feedback'

/** `disabled` holds the confirm back until the dialog's own condition is met, such as accepting the terms. */
export function ConfirmDialog({ open, title, children, action, intent = 'danger', busy, disabled, error, onConfirm, onCancel }: {
  open: boolean; title: string; children: ReactNode; action: string; intent?: 'primary' | 'neutral' | 'danger'; busy: boolean; disabled?: boolean; error?: string; onConfirm: () => void; onCancel: () => void
}) {
  const dialog = useRef<HTMLDialogElement>(null)
  const cancel = useRef<HTMLButtonElement>(null)
  const titleId = useId()
  const descriptionId = useId()
  useEffect(() => {
    if (!open) return
    const previous = document.activeElement as HTMLElement | null
    const element = dialog.current!
    element.showModal()
    cancel.current?.focus()
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      element.close()
      document.body.style.overflow = previousOverflow
      if (previous?.isConnected) previous.focus()
      else document.getElementById('main-content')?.focus()
    }
  }, [open])
  return <dialog ref={dialog} className="ui-dialog" aria-labelledby={titleId} aria-describedby={descriptionId} onCancel={(event) => { event.preventDefault(); if (!busy) onCancel() }}>
    <div className="dialog-body"><h2 id={titleId}>{title}</h2><div id={descriptionId}>{children}</div>{error && <Notice>{error}</Notice>}</div>
    <div className="dialog-actions"><button ref={cancel} type="button" className="ui-button" data-emphasis="outline" data-intent="neutral" disabled={busy} onClick={onCancel}>Cancelar</button><Button intent={intent} busy={busy} disabled={disabled} onClick={onConfirm}>{action}</Button></div>
  </dialog>
}
